<div
  id="main-content"
  class="flex w-full h-screen align-items-center justify-content-center"
>
  <router-outlet></router-outlet>
</div>
